import MenuService from "@/services/menuService";
const menuService = new MenuService();

export const state = {
  routes: [],
  menus: [], 
};

export const getters = {
  getRoutes(state) {
    return state.routes;
  },
  getMenus(state) {
    return state.menus;
  },
};

export const mutations = {
  addRoute(state, payload) {
    let value = state.routes.filter((x) => x.path === payload.path)
    if (value.length == 0) state.routes.push(payload);
  },
  clearRoutes(state) {
    state.routes.length = 0;
  },
  clearMenus(state) {
    state.menus = "";
  },
  setMenus(state, payload) {
    state.menus = payload;
  },
};

export const actions = {

  async addRoutesOnApiAction({ commit }) {
    commit('clearRoutes');
    let list = await menuService.GetUnacsMenuListByRoleId();
    flattenForRoutes(list.data.responseData, "");
    routeList.forEach(function (a) {
      commit('addRoute', a);
    });
  },

  async addRoutesAndMenuFromApi({ commit }) {
    commit('clearRoutes');
    commit('clearMenus');
    let result = await menuService.GetUnacsMenuListByRoleId();

    flattenForRoutes(result.data.responseData, "");
    routeList.forEach(function (route) {
      commit('addRoute', route);
    });
    let menuList =  getDynamicMenu(result.data.responseData)
    commit('setMenus', menuList);

  },

  addRouteAction({ commit }, { route }) {
    commit('addRoute', route);
  },
  clearRoutesAction({ commit }) {
    commit('clearRoutes');
  },
  setMenus(state, payload) {
    state.menuList = payload;
  },
  resetMenus(state) {
    state.menuList = "";
  }
};
let routeList = [];
function flattenForRoutes(array, pBreadcrumbText) {
  let breadcrumbText = pBreadcrumbText.length > 0 ? pBreadcrumbText + " > " : "";
  array.forEach(function (a) {
    if (Array.isArray(a.children)) {
      flattenForRoutes(a.children, breadcrumbText + a.name);
    }
    if (a.component != null) {
      let route = {
        path: `/${a.path}`,
        component: () => import(`@/views/${a.component}`),
        name: `${a.path.split("/").pop()}`,
        pageName: `${a.name}`,
        meta: {
          title: `${a.name}`,
          authRequired: true,
          requiresParams: !a.isShown,
          breadcrumbText: breadcrumbText
        }
      };
      routeList.push(route);
    }
  });
}

function getDynamicMenu(menuArr) {
  let menus = flattenForMenus(menuArr, "");
  let parsedMenus = jsonParser(menus);
  return JSON.stringify(parsedMenus);
}

function jsonParser(array) {
  let result = array.map(obj => {
    const filteredJSON = JSON.stringify(obj, (key, value) => {
      let resp = value;
      resp = value === null ? undefined : value
      if (resp === undefined && key === "icon") resp = "";
      return resp;
    });

    return JSON.parse(filteredJSON);
  });
  return result;
}

function flattenForMenus(array, pBreadcrumbText) {
 
  let breadcrumbText = pBreadcrumbText.length > 0 ? pBreadcrumbText + " > " : "";
  const result = [];
  array.forEach(function (a) {
    if (a.isShown) {
      let tmp = new MenuItem();
      tmp.title = a.name;
      tmp.icon = a.icon;
      tmp.route = a.path;
      tmp.component = a.component;
      tmp.children = null;
      tmp.href = a.name.replaceAll(" ", "");
      tmp.collapseitem = "#" + a.name.replaceAll(" ", "");
      tmp.breadcrumbText = breadcrumbText;

      if (Array.isArray(a.children)) {
        let flattenResp = flattenForMenus(a.children, breadcrumbText + a.name);
        if (flattenResp.length != 0) {
          tmp.children = flattenResp;
        }
      }
      if (tmp.breadcrumbText != "") {
        tmp.breadcrumbText = tmp.breadcrumbText.substr(0, tmp.breadcrumbText.length - 3);
      }
      result.push(tmp);
    }
  });
  return result;
}

class MenuItem {

  constructor(title, icon, route, component, href, children, collapseitem, breadcrumbText) {
    this.title = title;
    this.icon = icon;
    this.route = route;
    this.component = component;
    this.href = href;
    this.children = children;
    this.collapseitem = collapseitem;
    this.breadcrumbText = breadcrumbText;
  }

}